import { type CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js/max'

/** Onboarding phone fields that hold an E.164 number once normalized. */
export const ONBOARDING_PHONE_FIELDS = ['phone', 'ambassadorMobile', 'contactPhone'] as const

export const hasInternationalPrefix = (phone: string) => /^(\+|00)/.test(phone)

/** Rewrites a leading `00` IDD prefix to `+`; libphonenumber only understands `+`. */
export const withPlusPrefix = (phone: string) => phone.replace(/^00/, '+')

/**
 * Turns a prefilled national-format number (company record, scrape, AI) into
 * E.164 using the onboarding's default country, so PhoneField shows the
 * calling code and validation passes. Anything that can't be parsed into a
 * valid number is returned unchanged. A `00` prefix is rewritten to `+`;
 * numbers already starting with `+` are left as they are.
 */
export function normalizeOnboardingPhone(value: unknown, defaultCountry?: string | null): unknown {
  if (typeof value !== 'string') return value
  const phone = value.trim()
  if (!phone || phone.startsWith('+')) return value
  if (!phone.startsWith('00') && !defaultCountry) return value
  const parsed = phone.startsWith('00')
    ? parsePhoneNumberFromString(withPlusPrefix(phone))
    : parsePhoneNumberFromString(phone, defaultCountry?.toUpperCase() as CountryCode)
  return parsed?.isValid() ? parsed.number : value
}
